module.exports = __webpack_public_path__ + "sgby/img/dongzhuo-s.876d0c2.png";